import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CheckPermission, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser } from "../../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../../context";
import { DeleteJobsGroupApi, JobsGroupApi, JobsGroupChangeStatusApi } from "../../../api";
import { Link } from 'react-router-dom'

export const JobGroups = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "عنوان گروه شغلی ",
            render: (i: any) => (<div className="h-[40px] flex items-center">{i.name && i.name != null && i.name}</div>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
        {
            title: "وضعیت",
            render: (i: any) => (<>
                {CheckPermission(42) &&
                    <CToggle onChange={(e: any) => handelChangeToggle(e, i.name, i.id)} defaultChecked={i.status == 1 ? true : false} />
                }
            </>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-around ">
                    {CheckPermission(42) &&
                        <Link to={`/p/settings/job-groups/${i.id}`}>
                            <img src="/assetes/svg/edit.svg" className="w-[20px] cursor-pointer" />
                        </Link>
                    }
                    {CheckPermission(43) &&
                        <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] cursor-pointer" />
                    }
                </div>)
        },

    ]

    const handelChangeToggle = async (e: any, name: string, id: number) => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await JobsGroupChangeStatusApi(e.target.checked, name, id)
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.success) {
            toast("تغییر وضعیت صورت گرفت", { type: "success" })
            // getData()
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }

    }

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteJobsGroupApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData()
        }
        else {
            if (res.message) {
                toast(res.message, { type: "error" })
            }
            else {
                toast("خطایی رخ داده است", { type: "error" })
            }
        }
    }



    const getData = async () => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await JobsGroupApi()
            setTableData(res.data)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "گروه شغلی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 0, })
        getData()

    }, [])

    return (
        <div className=" w-full flex flex-col">



            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <h1 className="sm:text-2xl text-lg font-bold mb-[30px] md:mb-0">مدیریت گروه مشاغل</h1>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    {CheckPermission(41) ?
                        <button className=" w-full md:w-[120px] h-[30px] md:h-[40px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                            <Link to='/p/settings/job-groups/add' className=" w-full h-full flex justify-center items-center">
                                + ایجاد گروه شغلی
                            </Link>
                        </button>
                        :
                        <div />
                    }
                </div>
            </div>

            {CheckPermission(40) &&
                <div className=" w-full mt-[20px]">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} />
                        :
                        <CSkeletonTable />
                    }
                </div>
            }

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
